import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { ListReservation } from 'app/models/loyalty-reservation-search.models';

@Injectable()
export class LoyaltyReservationSearchAllService {
  baseUrl = HttpClientService.BASE_MS_LOYALTY;

  constructor(private http: HttpClientService) { }

  /**
    * Tramite metodo GET, restituisce la lista delle Reservation.
    * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<ListReservation>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/reservation/getReservationList` +
      (params.toString() ? '?view=ALL&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  /**
   * Chiammata a Filtri Extended Search
   */
  sendExtSearchQuery(data): Observable<{ data: any, metadata: ListMetadata }> {
    if (data.sortField && data.sortDir) {
      return this.http.postPaged(`${this.baseUrl}/reservation/getReservationList?view=ALL&offset=${data.offset}&limit=${data.limit}&sort=${data.sortField}&sort_dir=${data.sortDir}`, data.query);
    } else {
      return this.http.postPaged(`${this.baseUrl}/reservation/getReservationList?view=ALL&offset=${data.offset}&limit=${data.limit}`, data.query);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-reservation-search-all.service.ts